var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var ApiProductService = /** @class */ (function () {
    function ApiProductService(apiUrl) {
        if (apiUrl === void 0) { apiUrl = '/api/products'; }
        this.apiUrl = apiUrl;
    }
    /**
     * Get authentication headers with token
     */
    ApiProductService.prototype.getAuthHeaders = function () {
        var token = localStorage.getItem('redaktor_token');
        var headers = {
            'Content-Type': 'application/json',
        };
        if (token) {
            headers['Authorization'] = "Bearer ".concat(token);
        }
        return headers;
    };
    /**
     * Get authentication headers for form data (without Content-Type)
     */
    ApiProductService.prototype.getAuthHeadersForFormData = function () {
        var token = localStorage.getItem('redaktor_token');
        var headers = {};
        if (token) {
            headers['Authorization'] = "Bearer ".concat(token);
        }
        return headers;
    };
    /**
     * Fetch all wine products from the server API
     */
    ApiProductService.prototype.fetchProducts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var timestamp, response, errorText, data, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        timestamp = new Date().getTime();
                        return [4 /*yield*/, fetch("".concat(this.apiUrl, "?t=").concat(timestamp), {
                                cache: 'no-store',
                                headers: {
                                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                                    'Pragma': 'no-cache'
                                }
                            })];
                    case 1:
                        response = _a.sent();
                        if (!!response.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.text()];
                    case 2:
                        errorText = _a.sent();
                        throw new Error("HTTP error! status: ".concat(response.status, ", message: ").concat(errorText));
                    case 3: return [4 /*yield*/, response.json()];
                    case 4:
                        data = _a.sent();
                        console.log("\u2705 [ApiService] Fetched ".concat(data.length, " products"));
                        return [2 /*return*/, data];
                    case 5:
                        error_1 = _a.sent();
                        console.error('❌ [ApiService] Error fetching products:', error_1);
                        throw error_1;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Add a new wine product (requires authentication)
     */
    ApiProductService.prototype.addProduct = function (productData) {
        return __awaiter(this, void 0, void 0, function () {
            var response, errorData, result, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        return [4 /*yield*/, fetch(this.apiUrl, {
                                method: 'POST',
                                headers: this.getAuthHeadersForFormData(),
                                body: productData,
                            })];
                    case 1:
                        response = _a.sent();
                        if (!!response.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.json()];
                    case 2:
                        errorData = _a.sent();
                        throw new Error(errorData.message || "HTTP error! status: ".concat(response.status));
                    case 3: return [4 /*yield*/, response.json()];
                    case 4:
                        result = _a.sent();
                        return [2 /*return*/, result.product];
                    case 5:
                        error_2 = _a.sent();
                        console.error('Error adding product:', error_2);
                        throw error_2;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Update an existing wine product (requires authentication)
     */
    ApiProductService.prototype.updateProduct = function (id, productData) {
        return __awaiter(this, void 0, void 0, function () {
            var response, errorData, result, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        return [4 /*yield*/, fetch("".concat(this.apiUrl, "/").concat(id), {
                                method: 'PUT',
                                headers: this.getAuthHeadersForFormData(),
                                body: productData,
                            })];
                    case 1:
                        response = _a.sent();
                        if (!!response.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.json()];
                    case 2:
                        errorData = _a.sent();
                        throw new Error(errorData.message || "HTTP error! status: ".concat(response.status));
                    case 3: return [4 /*yield*/, response.json()];
                    case 4:
                        result = _a.sent();
                        return [2 /*return*/, result.product];
                    case 5:
                        error_3 = _a.sent();
                        console.error('Error updating product:', error_3);
                        throw error_3;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Delete a wine product (requires authentication)
     */
    ApiProductService.prototype.deleteProduct = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var response, errorData, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        return [4 /*yield*/, fetch("".concat(this.apiUrl, "/").concat(id), {
                                method: 'DELETE',
                                headers: this.getAuthHeaders(),
                            })];
                    case 1:
                        response = _a.sent();
                        if (!!response.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.json()];
                    case 2:
                        errorData = _a.sent();
                        throw new Error(errorData.message || "HTTP error! status: ".concat(response.status));
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        error_4 = _a.sent();
                        console.error('Error deleting product:', error_4);
                        throw error_4;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get a specific product by ID
     */
    ApiProductService.prototype.getProduct = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var response, errorData, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        return [4 /*yield*/, fetch("".concat(this.apiUrl, "/").concat(id))];
                    case 1:
                        response = _a.sent();
                        if (!!response.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.json()];
                    case 2:
                        errorData = _a.sent();
                        throw new Error(errorData.message || "HTTP error! status: ".concat(response.status));
                    case 3: return [4 /*yield*/, response.json()];
                    case 4: return [2 /*return*/, _a.sent()];
                    case 5:
                        error_5 = _a.sent();
                        console.error('Error fetching product:', error_5);
                        throw error_5;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    return ApiProductService;
}());
export { ApiProductService };
export var apiProductService = new ApiProductService();
